/**
 * PublicRoute Guard
 * Handles public routes with optional auth redirect
 */

import { Navigate } from 'react-router-dom';
import { isAuthenticated, getDefaultDashboardPath } from '../utils/auth';

interface PublicRouteProps {
  children: React.ReactNode;
  restricted?: boolean;
}

export const PublicRoute = ({ children, restricted = false }: PublicRouteProps) => {
  if (restricted && isAuthenticated()) {
    // Redirect to appropriate dashboard based on user role and profile status
    const defaultPath = getDefaultDashboardPath();
    return <Navigate to={defaultPath} replace />;
  }

  return <>{children}</>;
};
